$(document).ready(function () {

    /*
     * force strict mode
     */

    'use strict';

    /*
     * Set initial window width on document ready
     */

    window.windowWidth = $(window).outerWidth();

    /*
     * Set window breakpoints variable
     * call by using window.breakpoints.BREAKPOINT_NAME
     */
    window.breakpoints = getBreakpoint();

});

$(window).on('resize', debouncer(function (e) {
    'use strict';

    windowWidth = $(window).width();

})); // window resize